import {KEY_USER_ACCESS_TOKEN} from '../../constants';

import {
  getUser,
  getUserType,
  setUserType,
  getStoreEmployeeInfo,
  getMoengageData,
} from '../localstorage-data';
declare const window: any;
export const isLoggedInUser = (): boolean => {
  const _token = localStorage.getItem(KEY_USER_ACCESS_TOKEN);
  const _user = getUser();
  return _token && _user ? true : false;
};
export const isLoggedInEmployee = (): boolean => {
  //const _token = localStorage.getItem(KEY_USER_ACCESS_TOKEN);
  const _employee = getStoreEmployeeInfo();
  console.log(_employee);
  return _employee ? true : false;
};

export const logout = () => {
  const userType = getUserType();
  const moengageData = getMoengageData();
  if (userType === 'employee') {
    localStorage.clear();
    if (moengageData === true) {
      window.Moengage.destroy_session();
      window.location.href = '/employeesignin';
      return;
    } else {
      window.location.href = '/employeesignin';
    }
  }

  localStorage.clear();
  if (userType != null) {
    setUserType(userType);
  }
  if (moengageData === true) {
    window.Moengage.destroy_session();

    window.location.href = '/qrcode';
  } else {
    window.location.href = '/qrcode';
  }
};
